<div class="container">
    <h1 class="mt120">Statement of Faith</h1>
    <hr class="mb-0" />
</div>

<div class="mainContnet">
    <div class="container">
        <p>As adopted by the National Association of Evangelicals.</p>



        <ol>
            <li>We believe the Bible to be the inspired, the only infallible, authoritative Word of God. <em>Psalm
                    1:1-3; 2 Timothy 3:16; 2 Peter 1:20-21; Psalm 19:7-8</em>.</li>
            <li>We believe that there is one God, eternally existent in three persons: Father, Son, and Holy Spirit.
                <em>Matthew 3:16-17; John 4:24; Romans 8:5-11</em>.</li>
            <li>We believe in the deity of our Lord Jesus Christ, in His virgin birth, in His sinless life, in His
                miracles, in His vicarious and atoning death through His shed blood, in His bodily resurrection, in His
                ascension to the right hand of the Father, and in His personal return in power and glory. <em>John 1:1;
                    14; 8:58; 2 Corinthians 5:21; Ephesians 1:7; 1 John 2:2</em>.</li>
            <li>We believe that for the salvation of lost and sinful man, regeneration by the Holy Spirit is absolutely
                essential. <em>John 1:12; Romans 3:21-26; Ephesians 1:3-8</em>.</li>
            <li>We believe in the present ministry of the Holy Spirit by whose indwelling the Christian is enabled to
                live a godly life. <em>Acts 1:8; 2:1-4; Galatians 5:16-25; Ephesians 5:18</em>.</li>
            <li>We believe in the resurrection of both the saved and the lost; they that are saved unto the resurrection
                of life and they that are lost unto the resurrection of damnation. <em>John 5:28-29; Revelation
                    20:4-6</em>.</li>
            <li>We believe in the spiritual unity of believers in our Lord Jesus Christ. <em>John 17:11, 21-23</em>.
            </li>
        </ol>



        <p><strong><em>“In essentials unity… In non-essentials liberty… In all things love.”</em></strong></p>
    </div>
    <app-static-footer></app-static-footer>
</div>